import React from "react";
import "./chip.scss";

export const Chip = ({ label }) => {
    return <span className="custom-chip">{label}</span>;
};
